import { render, staticRenderFns } from "./ButtonAttachment.vue?vue&type=template&id=5d579434"
import script from "./ButtonAttachment.vue?vue&type=script&lang=js"
export * from "./ButtonAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports